import Config from '@/Config';
import Resources from '@/Resources';
import { projectListItemTypes, projectPhaseSearchType, refParamTypes } from '@/Models';
import { addRefWithOptions } from '@/Utils/UrlUtility';

function getProjectListItemTypeResource(projectListItemType) {
    return Resources.Homepage[projectListItemTypes[projectListItemType].displayName];
}

function buildSearchUrl(phaseTypes) {
    const phaseTypesArray = Array.isArray(phaseTypes) ? phaseTypes : [phaseTypes];
    const phaseNames = phaseTypesArray.map(type => projectPhaseSearchType[type].name);
    return `${Config.navigation.searchUrl}?ProjectPhaseSearchTypes=${phaseNames.join(',')}`;
}

export function useExploreNavigation() {
    const navigationItems = [
        {
            name: getProjectListItemTypeResource(projectListItemTypes.upcoming),
            url: addRefWithOptions(buildSearchUrl(
                projectPhaseSearchType.upcoming,
            ), { page: refParamTypes.exploreRef, section: 'mobile-navigation', suffix: 'upcoming', index: 1 }),
        },
        {
            name: getProjectListItemTypeResource(projectListItemTypes.crowdfunding),
            url: addRefWithOptions(buildSearchUrl(
                projectPhaseSearchType.crowdfunding,
            ), { page: refParamTypes.exploreRef, section: 'mobile-navigation', suffix: 'crowdfunding', index: 2 }),
        },
        {
            name: getProjectListItemTypeResource(projectListItemTypes.latePledge),
            url: addRefWithOptions(buildSearchUrl(
                projectPhaseSearchType.latePledge,
            ), { page: refParamTypes.exploreRef, section: 'mobile-navigation', suffix: 'latePledge', index: 3 }),
        },
        {
            name: getProjectListItemTypeResource(projectListItemTypes.storesAndPreorders),
            url: addRefWithOptions(buildSearchUrl([
                projectPhaseSearchType.store,
                projectPhaseSearchType.preorder,
            ]), { page: refParamTypes.exploreRef, section: 'mobile-navigation', suffix: 'storesAndPreorders', index: 4 }),
        }];

    return {
        navigationItems,
    };
}